// Vanilla JS
const data = {};

// Query DOM Elements
const poModalList = document.querySelector('.po-modal--list');
const poMmodalBg = '<div class="po-modal--bg"></div>';

export const poModal = function () {
	const getObraDescription = function () {
		if (data.modal.dataset.obraDescription)
			return `<div class="tech--description">${data.modal.dataset.obraDescription}</div>`;
		else return false;
	};

	const setDescriptionHeight = function () {
		if (getObraDescription()) {
			const descriptionEl = document.querySelector('.tech--description');
			const descriptionHeight =
				(data.screenH - data.modalHeight) / 2 - 30;
			descriptionEl.style.maxHeight = `${descriptionHeight}px`;
			if (descriptionEl.scrollHeight > descriptionEl.clientHeight)
				descriptionEl.classList.add('has-scroll');
		}
	};

	/**
	 * Render Modal
	 */
	const renderModalWindow = function () {
		const arrDataSets = [];
		/*
        data.modal.dataset.obraTitle && arrDataSets.push(data.modal.dataset.obraTitle);
        data.modal.dataset.dateObra && arrDataSets.push(data.modal.dataset.dateObra);
        data.modal.dataset.obraLocal && arrDataSets.push(data.modal.dataset.obraLocal);
        data.modal.dataset.obraTecnica && arrDataSets.push(data.modal.dataset.obraTecnica);
        data.modal.dataset.obraDimensoes && arrDataSets.push(data.modal.dataset.obraDimensoes);
        const info = arrDataSets.join(', ');
        */
		const obraTitle = data.modal.dataset.obraTitle
			? `<span>${data.modal.dataset.obraTitle}</span>`
			: '';
		const obraDate = data.modal.dataset.dateObra
			? `<span>${data.modal.dataset.dateObra}</span>`
			: '';
		const obraLocal = data.modal.dataset.obraLocal
			? `<span>${data.modal.dataset.obraLocal}</span>`
			: '';
		const obraTecnica = data.modal.dataset.obraTecnica
			? `<span>${data.modal.dataset.obraTecnica}</span>`
			: '';
		const obraDimensoes = data.modal.dataset.obraDimensoes
			? `<span>${data.modal.dataset.obraDimensoes}</span>`
			: '';
		const obraExpo = data.modal.dataset.obraExpo
			? `<br><span>Exposições: ${data.modal.dataset.obraExpo}</span>`
			: '';

		obraDate && arrDataSets.push(obraDate);
		obraLocal && arrDataSets.push(obraLocal);
		obraTecnica && arrDataSets.push(obraTecnica);
		obraDimensoes && arrDataSets.push(obraDimensoes);
		obraExpo && arrDataSets.push(obraExpo);

		const info =
			arrDataSets.length > 0
				? `<span class="tech--meta">${arrDataSets.join(', ')}</span>`
				: '';

		document.querySelector('.po-modal--window') &&
			document.querySelector('.po-modal--window').remove();

		const mDescription = getObraDescription() ? getObraDescription() : '';

		data.window = `
        <div class="po-modal--window" style="top: ${
			window.scrollY + data.screenH / 2
		}px; width: ${data.modalWidth}px" data-modal-height="${
			data.modalHeight
		}">
            <div class="po-modal--wrapper">
            <img src="/wp-content/themes/bootscore-child-main/assets/img/logo/ts-logo.svg" alt="logo" class="logo md">
            <span class="po-modal--close"><i class="fa-solid fa-x"></i></span>
            <div class="po-modal--img"><img src="${
				data.modal.dataset.imageUrl
			}" alt="${data.modal.dataset.obraTitle}"></div>
            <div class="po-modal--info">
                <div class="tech--data">
					<em>${obraTitle}${info ? ', ' : ''}</em>
					${info}
                </div>
                ${mDescription}
            </div>
            </div>
            <div class="po-modal--nav">
            <span class="po-modal--nav--btn po-modal--prev"><span><i class="fa-solid fa-angle-left"></i></span></span>
            <span class="po-modal--nav--btn po-modal--next"><span><i class="fa-solid fa-angle-right"></i></span></span>
            </div>
        </div>
        `;
		document.body.insertAdjacentHTML('beforeend', data.window);
		setTimeout(
			() =>
				document
					.querySelector('.po-modal--window ')
					.classList.add('po-modal__show'),
			100
		);
		document.body.style.overflow = 'hidden';

		setDescriptionHeight();
		poModalNav();
		poCloseModal();
	};

	/**
	 * Define size and position of Modal
	 */
	const setModalSize = function () {
		const modalImg = new Image();
		modalImg.onload = function () {
			data.screenW = window.innerWidth;
			data.screenH = window.innerHeight;
			const imgHeight = modalImg.height;
			const imgWidth = modalImg.width;
			const imgScrRatio =
				data.screenW / data.screenH - imgWidth / imgHeight;
			let wMargin;

			if (data.screenW <= 768) {
				wMargin = 40;
			} else {
				if (getObraDescription()) {
					if (imgScrRatio >= 0 && imgWidth > imgHeight) {
						wMargin = 320;
					} else if (imgScrRatio >= 0 && imgHeight > imgWidth) {
						wMargin = 180;
					} else if (imgScrRatio < 0) {
						wMargin = 240;
					}
				} else {
					if (imgScrRatio >= 0 && imgWidth > imgHeight) {
						wMargin = 220;
					} else if (imgScrRatio >= 0 && imgHeight > imgWidth * 3) {
						wMargin = 30;
					} else if (imgScrRatio >= 0 && imgHeight > imgWidth * 2) {
						wMargin = 60;
					} else if (imgScrRatio >= 0 && imgHeight > imgWidth) {
						wMargin = 120;
					} else if (imgScrRatio < 0) {
						wMargin = 180;
					} else {
						wMargin = 80;
					}
				}
			}

			if (imgScrRatio >= 0) {
				// if vertical ratio
				data.modalWidth =
					(data.screenH * imgWidth) / imgHeight - wMargin;
			}
			if (imgScrRatio < 0) {
				// if horizontal ratio
				data.modalWidth = data.screenW - wMargin;
			}
			data.modalHeight = (data.modalWidth * imgHeight) / imgWidth;

			// Output:
			return renderModalWindow();
		};
		modalImg.src = data.modal.dataset.imageUrl;
	};

	/**
	 * Add button to the list
	 * to activate individual Modal Windows
	 */
	poModalList.addEventListener('click', function (e) {
		if (!e.target.closest('.po-modal--btn')) return;

		const poModal = e.target.closest('.po-modal');
		if (!poModal) return;

		data.modal = poModal;
		document.body.insertAdjacentHTML('beforeend', poMmodalBg);
		setTimeout(
			() =>
				document
					.querySelector('.po-modal--bg')
					.classList.add('po-modal__show'),
			50
		);

		return setModalSize();
	});

	/**
	 * Modal Navigation
	 * Slides to next/prev image
	 */
	const poModalNav = function () {
		const poModalLength =
			document.querySelectorAll('[data-modal-n]').length;
		const poModalNum = +data.modal.closest('.po-modal').dataset.modalN;
		const nextBtn = document.querySelector('.po-modal--next');
		const prevBtn = document.querySelector('.po-modal--prev');

		if (poModalNum === 1) prevBtn.style.display = 'none';

		if (poModalNum >= poModalLength) nextBtn.style.display = 'none';

		const imageNav = function (e) {
			const navBtn = e.target.closest('.po-modal--nav--btn');
			if (!navBtn) return;

			document.querySelector('.po-modal--window').remove();

			const poModalNewNum = navBtn.classList.contains('po-modal--next')
				? poModalNum + 1
				: poModalNum - 1;
			data.modal = document.querySelector(
				`[data-modal-n = '${poModalNewNum}']`
			);
			setModalSize();
		};

		poModalLength > 1 && nextBtn.addEventListener('click', imageNav);
		poModalNum <= poModalLength &&
			prevBtn.addEventListener('click', imageNav);
	};

	/**
	 * Close Modal
	 */
	const poCloseModal = function () {
		const poModalCloseBtn = document.querySelector('.po-modal--close');
		const poModalBg = document.querySelector('.po-modal--bg');
		const poModalWindow = document.querySelector('.po-modal--window');

		[poModalCloseBtn, poModalBg].forEach((el) =>
			el.addEventListener('click', function () {
				poModalWindow.remove();
				poModalBg.remove();
				delete data.modal, data.window;
				document.body.style.removeProperty('overflow');
			})
		);
	};
};
